/**
 * Middleware de request context — Structura Food Market.
 * Agrega correlation ID y structured logging al contexto de cada request.
 */
import { createMiddleware } from "@tanstack/react-start";
import { logServerEvent } from "@/lib/sm-http";

export const REQUEST_ID_HEADER = "x-request-id";
export const CORRELATION_ID_HEADER = "x-correlation-id";

function resolveRequestId(request: Request): string {
  return (
    request.headers.get(CORRELATION_ID_HEADER) ??
    request.headers.get(REQUEST_ID_HEADER) ??
    request.headers.get("x-nf-request-id") ??
    crypto.randomUUID()
  );
}

/**
 * Middleware que loggea cada request API con requestId, método y path.
 * Solo loggea rutas /api/* para evitar spam de rutas de página.
 */
export const requestContextMiddleware = createMiddleware().server(async ({ request, next }) => {
  const url = new URL(request.url);

  // Solo loggear rutas API
  if (!url.pathname.startsWith("/api/")) return next();

  const requestId = resolveRequestId(request);

  logServerEvent("info", "api.request", requestId, {
    method: request.method,
    path: url.pathname,
  });

  return next();
});
